import { ModifyIdentity } from '@grid/models';
import { BooleanTerminologyType } from '@shared/enums/boolean-terminology';
import { DataType } from '@shared/models';
import { DprActivityCustomData } from '@shared/models/dpr';

export interface DprActivityCustomDataGridData
  extends ModifyIdentity<DprActivityCustomData> {
  decimalCount?: number;
  // TODO - Check the usage of dataTypeId property, as it is inconsistently used throughout the application
  // (there are places where it is populated and places where it is not, leading to confusion)
  dataTypeId?: DataType;
  remarks?: string;
  name?: string;
  booleanTerminologyId?: BooleanTerminologyType;
}
